import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export const Shipping = () => {
  return (
    <section className="min-h-screen bg-[#0A0E14] pt-24 md:pt-32 pb-16 md:pb-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 md:px-8">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-green-400 hover:text-green-300 mb-8 transition-colors"
        >
          <ArrowLeft size={20} />
          <span className="text-sm">Back to Home</span>
        </Link>

        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Shipping & Delivery</h1>
        <p className="text-gray-400 mb-12">Last updated: January 2025</p>

        <div className="glass-card rounded-2xl p-8 md:p-12 space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Digital Service Delivery</h2>
            <p className="leading-relaxed mb-4">
              MBhost is a cloud infrastructure platform that provides <strong>digital services only</strong>. As we do not ship physical products, traditional shipping policies do not apply to our services.
            </p>
            <p className="leading-relaxed">
              All our services are delivered electronically and are available immediately upon successful account creation and payment processing.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Service Provisioning Timeline</h2>
            <p className="leading-relaxed mb-4">
              Our services are provisioned as follows:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Instant Provisioning:</strong> Most services are available within 2-5 minutes of account creation</li>
              <li><strong>Compute Instances:</strong> Deployed within 60 seconds of order confirmation</li>
              <li><strong>Databases:</strong> Provisioned within 5-10 minutes</li>
              <li><strong>Custom Configurations:</strong> May take up to 24 hours for complex setups</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Access & Delivery</h2>
            <p className="leading-relaxed mb-4">
              Upon successful registration:
            </p>
            <ol className="list-decimal list-inside space-y-2 ml-4">
              <li>You receive immediate access to your MBhost dashboard</li>
              <li>Account credentials are sent to your registered email</li>
              <li>API keys and access tokens are generated instantly</li>
              <li>All documentation and resources are available in your account</li>
            </ol>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Service Availability</h2>
            <p className="leading-relaxed">
              Our cloud infrastructure is available 24/7/365 with 99.99% uptime guarantee. You can access your services from anywhere in the world through our web dashboard, CLI tools, or API.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Hardware Shipments (If Applicable)</h2>
            <p className="leading-relaxed mb-4">
              In rare cases where physical hardware may be involved (such as dedicated servers or security keys):
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Shipping within India: 3-7 business days</li>
              <li>Metro cities: 2-3 business days</li>
              <li>Remote locations: 7-10 business days</li>
              <li>Shipping costs are communicated before purchase</li>
            </ul>
            <p className="leading-relaxed mt-4">
              Note: Physical shipments are available only for enterprise customers on request.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Data Migration Services</h2>
            <p className="leading-relaxed">
              For customers migrating from other platforms, we offer data transfer services. Migration timelines depend on data volume and are discussed during onboarding.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Support & Onboarding</h2>
            <p className="leading-relaxed">
              All customers receive:
            </p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Instant access to documentation and guides</li>
              <li>24/7 customer support via email and chat</li>
              <li>Dedicated onboarding assistance for enterprise plans</li>
              <li>Video tutorials and knowledge base access</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">Contact Us</h2>
            <p className="leading-relaxed">
              For questions about service delivery:
              <br />
              Email: <span className="text-green-400">support@mbhost.in</span>
              <br />
              Phone: +91-XXXX-XXXXXX
              <br />
              MBhost Cloud Pvt Ltd, A unit of MBT Ventures Ltd.
            </p>
          </section>
        </div>
      </div>
    </section>
  );
};